// Buyer Review Queue — thin role wrapper.
import React from 'react';
import OrchestratorReviewQueuePage from './OrchestratorReviewQueuePage';
import { useBreadcrumbUpdater } from '@ciea.ai/smart-infra-navigation';

const BuyerReviewQueuePage: React.FC = () => {
  useBreadcrumbUpdater([{ path: '/buyer', breadcrumb: 'Buyer Review' }]);
  return <OrchestratorReviewQueuePage role="buyer" />;
};
export default BuyerReviewQueuePage;
